import Register from '../models/register.model'

let storeContent = utils.generateStore({
   Register,
   step: 0,
   steps: [
      {name: 'Card Info', min: 1, max: 2},
      {name: 'Capture Details', min: 3, max: 4},
      {name: 'PIN Validation', min: 5, max: 6},
      {name: 'Payment', min: 7, max: 7},
      {name: 'Payment Status', min: 8, max: 9},
   ],
   cards: [],
   payment_options: [
      {
         currency: 'KES',
         amount_per_card: 200,
         deposit_per_card: 5000,
      }
   ],
   pickupStation: '',
   instructions: '',
   paymentOption: null,
   vehicleRestriction: true,
   customer: '',
   retryCounts: 0,
   maxRetryCounts: 60,
   resendTimeOut: 30000,
   showResend: false,
   isEditing: false
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters,
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      moveNext(ctx){
         if(ctx.getters.step < 8){
            scroll(0, 0)
            ctx.commit('step', ctx.getters.step + 1);
         }
      },
      async isFormValid(ctx,payload){
         if (await payload.ref.isValid()) {
            return true;
         }else{
            return false;
         }
      },
      async verifyOTP(ctx,payload){
         try {
            ctx.commit('loading', true)

            let data = payload.ref.formData_
            if (await payload.ref.isValid()) {
               let channel = 'SMS'
               if(ctx.getters.step === 7){channel = 'E-MAIL'}

               let res = await api.fetchEndpoint({
                  resource: "customer",
                  action: "verify:otp",
                  data: {
                     otp: data.otp,
                     customerID: await $session.get('customer_id'),
                     channel
                  },
                  meta_data: {}
               })

               ctx.commit('step',8)
               $notify('success', 'OTP Verified', `OTP successfully verified.`)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async submitPaymentReceipt(ctx,payload){
         try {
            ctx.commit('loading', true)

            let data = payload.ref.formData_
            if (await payload.ref.isValid()) {

               let res = await api.fetchEndpoint({
                  resource: "registration",
                  action: "submit:payment_receipt",
                  data: {
                     payment_receipt: data.payment_receipt,
                     customer_id: await $session.get('customer_id'),
                  },
                  meta_data: {}
               })

               ctx.commit('step',10)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async sendMpesaRequest(ctx,payload){
         try {
            ctx.commit('loading', true)

            for (let i = 0; i < ctx.getters.cards.length; i++) {
               const card = ctx.getters.cards[i];
               let deposit = payload.deposits[i].toString().split(",").join("")
               let result = await validate(deposit, `required|numeric|min_value:2000`, { name: `top up amount for card ${card.name}` })
               if (!result.valid) {
                  $notify('warning', 'Validation Error', result.errors[0])
                  ctx.commit('loading', false)
                  return false
               }
            }
            let result = await validate(payload.mobile, `required|numeric|min:9|max:10`, { name: 'mobile number' })
            if (!result.valid) {
               $notify('warning', 'Validation Error', result.errors[0])
               ctx.commit('loading', false)
               return false
            }

            let res = await api.fetchEndpoint({
               resource: "mpesa",
               action: "call:mpesa",
               data: {
                  amount: payload.amount.toString().split(",").join(""),
                  customerID: await $session.get('customer_id'),
                  deposits: payload.deposits,
                  contact: payload.mobile
               },
               meta_data: {}
            })
            await $session.set('transactionID', res.result.tran_id)

            ctx.dispatch('fetchTransactionStatus')
            $notify('success', 'Payment Request', `A payment prompt has been sent to your mobile phone, pay to continue.`)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async submitPaymentMethod(ctx,payload){
         try {
            ctx.commit('loading', true)

            for (let i = 0; i < ctx.getters.cards.length; i++) {
               const card = ctx.getters.cards[i];
               let deposit = payload.deposits[i].toString().split(",").join("")
               let result = await validate(deposit, `required|numeric|min_value:${ctx.getters.paymentOption.deposit_per_card}`, { name: `top up amount for card ${card.name}` })
               if (!result.valid) {
                  $notify('warning', 'Validation Error', result.errors[0])
                  ctx.commit('loading', false)
                  return false
               }
            }

            let res = await api.fetchEndpoint({
               resource: "registration",
               action: "submit:payment_option",
               data: {
                  customer_id: await $session.get('customer_id'),
                  payment_option: ctx.getters.paymentOption._id,
                  deposits: payload.deposits.map((el) => { console.log(el); return Number(el.toString().split(",").join(""))}),
               },
               meta_data: {}
            })

            ctx.commit('instructions', res.result.instructions)
            ctx.commit('step', 9)
            $notify('success', 'Payment Option Submitted', `Payment option successfully submitted.`)
            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async fetchTransactionStatus(ctx){
         try{
            let interval = setInterval(async () => {
               ctx.commit('retryCounts', ctx.getters.retryCounts + 1)
               let res = await api.fetchEndpoint({
                  resource: "customer",
                  action: "query:tranaction_status",
                  data: {
                     transactionID: await $session.get('transactionID'),
                  },
                  meta_data: {}
               })

               if (res.result.tran.processing_status === 'PROCESSED' || res.result.tran.processing_status === 'SUCCESS'){
                  ctx.commit('loading', false)
                  ctx.commit('step',10)
                  clearInterval(interval)
               } else if (res.result.tran.processing_status === 'FAILED'){
                  ctx.commit('loading', false)
                  ctx.commit('step', 9)
                  clearInterval(interval)
               } else{
                  if (ctx.getters.retryCounts >= ctx.getters.maxRetryCounts){
                     ctx.commit('loading', false)
                     ctx.commit('step', 9)
                     clearInterval(interval)
                  }
               }
            }, 5000);
         }catch(err){
            throw err
         }
      },
      async resendOTP(ctx,payload){
         try {
            ctx.commit('loading', true)

            let channel = 'SMS'
            if(ctx.getters.step === 7){channel = 'E-MAIL'}

            await api.fetchEndpoint({
               resource: "customer",
               action: "resend:otp",
               data: {
                  customerID: await $session.get('customer_id'),
                  channel
               },
               meta_data: {}
            })

            $notify('success', 'OTP Verified', `OTP successfully re-sent.`)
            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async addCard(ctx,payload){
         if (await payload.left.isValid() && await payload.right.isValid()){
            payload.left.formData_.name = payload.left.formData_.name.toUpperCase()
            payload.right.formData_.vehicleReg = payload.right.formData_.vehicleReg.toUpperCase()
            let cards = ctx.getters.cards, card = { ...payload.left.formData_, ...payload.right.formData_ }
            cards.push(card)
            ctx.commit('cards',cards)

            // Logic to clear fields in cards
            if(ctx.getters.customer === 'B2C'){
               payload.left.formData_ = {
                  name: '',
                  mobileNo: {
                     mobile: '',
                     code: {
                        callingCode: '254',
                        countryCode: 'KE'
                     }
                  },
                  idType: '',
                  idNumber: '',
                  productRestriction: [],
                  authorizedZones: [],
               }
               payload.right.formData_ = {
                  email: '',
                  promoCode: card.promoCode,
                  daysOfUse: [],
                  vehicleReg: '',
                  sms: false,
                  millageInput: false,
                  driverCode: false,
               }
            }else{
               payload.left.formData_ = {
                  name: '',
                  companyName: card.companyName,
                  companyRegistrationNo: card.companyRegistrationNo,
                  mobileNo: {
                     mobile: '',
                     code: {
                        callingCode: '254',
                        countryCode: 'KE'
                     }
                  },
                  idType: '',
                  idNumber: '',
                  productRestriction: [],
                  authorizedZones: [],
               }
               payload.right.formData_ = {
                  email: '',
                  daysOfUse: [],
                  vehicleReg: '',
                  sms: false,
                  millageInput: false,
                  driverCode: false,
               }

               // Logic to make fields static
               let Model = ctx.getters.Register
               Model = utils.updateModelForm({
                  formName: 'company_card_details_left',
                  model: Model,
                  formModel: 'companyName',
                  field: 'disabled',
                  data: true,
               })
               Model = utils.updateModelForm({
                  formName: 'company_card_details_left',
                  model: Model,
                  formModel: 'companyRegistrationNo',
                  field: 'disabled',
                  data: true,
               })
               Model = utils.updateModelForm({
                  formName: 'card_details_right',
                  model: Model,
                  formModel: 'promoCode',
                  field: 'disabled',
                  data: true,
               })
               console.log('Model',Model)
               ctx.commit('Register', Model)
            }
         }
      },
      async registerIndividual(ctx){
         try {
            ctx.commit('loading', true)
            let cards = ctx.getters.cards

            let res = await api.fetchEndpoint({
               resource: "customer",
               action: "add:individualCustomer",
               data: {
                  name: cards[0].name.toUpperCase(),
                  idType: cards[0].idType,
                  idNumber: cards[0].idNumber,
                  mobileNumber: cards[0].mobileNo.code.callingCode + cards[0].mobileNo.mobile,
                  email: cards[0].email,
                  cards,
                  promoCode: cards[0].promoCode,
                  station: ctx.getters.pickupStation._id,
               },
               meta_data: {}
            })

            await $session.set('customer_id',res.result.customer._id)
            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async registerCorporate(ctx,payload){
         try {
            ctx.commit('loading', true)
            let cards = ctx.getters.cards

            let res = await api.fetchEndpoint({
               resource: "customer",
               action: "add:companyCustomer",
               data: {
                  companyName: cards[0].companyName,
                  companyRegistrationNo: cards[0].companyRegistrationNo,
                  mobileNumber: cards[0].mobileNo.code.callingCode + cards[0].mobileNo.mobile,
                  email: cards[0].email,
                  cards,
                  promoCode: cards[0].promoCode,
                  station: ctx.getters.pickupStation._id,
               },
               meta_data: {}
            })

            await $session.set('customer_id',res.result.customer._id)
            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            Event.$on('select-field-changed',(payload) => {
               if (payload.form.model === 'county'){
                  let stations = utils.appendSelectData({
                     form: Register.forms.pickup_station,
                     model: 'station',
                     label: 'name',
                     data: payload.data.stations
                  })

                  if (stations) {
                     let Model = ctx.getters.Register
                     Model.forms.pickup_station = stations
                     ctx.commit('Register', Model)
                  }
               } else if (payload.form.model === 'station') {
                  ctx.commit('pickupStation', payload.data)
               } else if (payload.form.model === 'payment_option'){
                  ctx.commit('paymentOption', payload.data)
               }
            })
            // Fetch User Groups
            let res = await api.fetchEndpoint({
               resource: "registration",
               action: "get:counties",
               data: {},
               meta_data: {}
            })
            let form = utils.appendSelectData({
               form: Register.forms.county_select,
               model: 'county',
               label: 'name',
               data: res.result.counties
            })

            if (form) {
               let Model = ctx.getters.Register
               Model.forms.county_select = form
               ctx.commit('Register', Model)
            }

            res = await api.fetchEndpoint({
               resource: "registration",
               action: "get:payment_options",
               data: {},
               meta_data: {}
            })
            ctx.commit('payment_options', res.result.options)
            console.log(res.result.options)

            form = utils.appendSelectData({
               form: Register.forms.select_payment_option,
               model: 'payment_option',
               label: 'name',
               data: res.result.options
            })

            if (form) {
               let Model = ctx.getters.Register
               Model.forms.select_payment_option = form
               ctx.commit('Register', Model)
            }
         } catch (err) {
            console.log(err)
            // throw err
         }
      },
      resetResendTimer(ctx){
         ctx.commit('showResend', false)
         
         setTimeout(() => {
            ctx.commit('showResend', true)
         }, resendTimeOut);
      },
      restrictionChanged(ctx){
         ctx.commit('vehicleRestriction', !ctx.getters.vehicleRestriction);
      },
      previousPage(ctx){
         ctx.commit('step', !ctx.getters.step - 1);
      },
      changeCustomer(ctx, payload) {
         ctx.commit('customer', payload.val)
         if(ctx.getters.customer === 'B2C'){
            
         }else{
            
         }
      },
   }
};